import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface Odometer {
  id: string;
  [key: string]: any;
}

// API response shape
interface OdometerListResponse {
  odometer: Odometer[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface OdometerState {
  data: OdometerListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface OdometerUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: OdometerState = {
  data: null,
  loading: false,
  error: null,
};

const odometerSlice = createSlice({
  name: "odometer",
  initialState,
  reducers: {
    setOdometerList(state, action: PayloadAction<OdometerListResponse>) {
      state.data = action.payload;
      console.log(
        action.payload,
        " action.payload action.payload action.payload_______"
      );
      state.loading = false;
      state.error = null;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setOdometerList, setLoading, setError } = odometerSlice.actions;

export default odometerSlice.reducer;
